import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';

@Component({
    selector: 'app-jumper',
    templateUrl: './jumper.component.html',
    styleUrls: ['./jumper.component.scss'],
    standalone: true,
    imports: [
        MatFormField,
        MatInput,
        MatIconButton,
        MatIcon,
    ],
})
export class JumperComponent implements AfterViewInit, OnDestroy {

  @Input() currentItemIndex = 1; // 1-based index of the currently shown item
  @Input() numberOfItems = 1; // total amount of items
  @Input() debounceTime = 500;
  @Input() prefix = '';
  @Input() showSideArrows = false;

  @Output() currentItemChanged: EventEmitter<number> = new EventEmitter();
  @ViewChild('itemIndexInput') itemIndexInput: ElementRef;

  private componentDestroyed: Subject<void> = new Subject();

  constructor() {
  }

  ngAfterViewInit(): void {
    fromEvent(this.itemIndexInput.nativeElement, 'input')
        .pipe(debounceTime(this.debounceTime), takeUntil(this.componentDestroyed))
        .subscribe((e: InputEvent) => {
          const input = parseInt(e.target['value']);
          if (input >= 1 &&
              input <= this.numberOfItems &&
              input !== this.currentItemIndex) {
            // update only if input is valid
            this.currentItemChanged.emit(input);
          } else {
            // set previous input value
            this.itemIndexInput.nativeElement.value = this.currentItemIndex.toString(10);
          }
        });
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
  }

  /**
   * Increase current item index by 1
   */
  next() {
    this.itemIndexInput.nativeElement.stepUp();
    // .stepUp() doesn't actually trigger a listenable event, it just changes input value
    this.itemIndexInput.nativeElement.dispatchEvent(new Event('input'));
  }

  /**
   * Decrease current item index by 1
   */
  previous() {
    this.itemIndexInput.nativeElement.stepDown();
    // .stepDown() doesn't actually trigger a listenable event, it just changes input value
    this.itemIndexInput.nativeElement.dispatchEvent(new Event('input'));
  }

}
